/**
 * @generated SignedSource<<78bb7c50b2d3c5d0cd05a8b3a8bd9461>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineFeedback_feedback$data = {
  readonly body: string | null;
  readonly contact: {
    readonly email: string | null;
    readonly name: string | null;
    readonly phoneNumber: string | null;
  } | null;
  readonly createdAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly createdByActor: {
    readonly " $fragmentSpreads": FragmentRefs<"SignedActor_actor">;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "TodoTimelineFeedback_feedback";
};
export type TodoTimelineFeedback_feedback$key = {
  readonly " $data"?: TodoTimelineFeedback_feedback$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineFeedback_feedback">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineFeedback_feedback",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "createdByActor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignedActor_actor"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "createdAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoContact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoFeedback",
  "abstractKey": null
};

(node as any).hash = "bc168b49ab9832689aec9db9f6727dee";

export default node;
